module.exports = __webpack_public_path__ + "static/media/circle.01939e87.svg";